import { render, staticRenderFns } from "./ProductItemFeatureEdit.vue?vue&type=template&id=22ef391d&"
import script from "./ProductItemFeatureEdit.vue?vue&type=script&lang=js&"
export * from "./ProductItemFeatureEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports